import { getQuery } from "utils/api";

// Outstanding comment requests for the signed-in tutor, for the nav badge.
// Shared per page load; the inbox page calls refreshCommentCount after an answer.
export const COMMENT_COUNT_EVENT = "comment-inbox-changed";

let request = null;

export const fetchCommentCount = () => {
  if (!request) {
    request = getQuery("comment/inbox")
      .then((res) => (res.data?.result || []).filter((r) => r.status === "outstanding").length)
      .catch(() => {
        request = null;
        return 0;
      });
  }
  return request;
};

export const refreshCommentCount = () => {
  request = null;
  window.dispatchEvent(new Event(COMMENT_COUNT_EVENT));
};
